import React from "react";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { withNamespaces } from "react-i18next";

const styles = (theme) => ({
  poolInfoCard: {
    marginTop: "32px",

    marginBottom: "45px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "48px",
      marginBottom: "64px",
    },
  },
  poolDescription: {
    color: theme?.colors?.presale?.cardText,
    fontSize: "18px",
    lineHeight: "24px",
    wordBreak: "break-word",
    whiteSpace: "pre-line",

    [theme.breakpoints.up("sm")]: {
      fontSize: "20px",
    },
  },
});

const DescriptionCard = ({ classes, poolInfo }) => {
  return (
    <div className={classes.poolInfoCard}>
      <Typography variant="h1" className={classes.poolDescription}>
        {poolInfo.description || "..."}
      </Typography>
    </div>
  );
};

export default withNamespaces()(
  withRouter(withStyles(styles)(DescriptionCard))
);
